<template>
  <div class="divider">
    <span>{{ label }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.divider {
  margin: 20px 0px 4px 0px;
  font-size: 0.875rem;
  font-weight: bold;
  background: $color-secondary;
  box-shadow: 1px 2px 5px #ccc;
  padding: 4px;
}
</style>
